import React from 'react';
import ReactDom from 'react-dom';
import userSetAction from '../../actions/userSetAction';

class TeamModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.state = {
            team:"",
            warningMsg: "",
            staffId: "",
            clientHeight: 200,
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {
        let clientHeight = ReactDom.findDOMNode(this.refs.modal).clientHeight;

        this.setState({
            team: this.props.team,
            clientHeight: clientHeight,
        });

    }
    handleChange(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        if (index == 0) {
            let team = this.state.team;
            team[this.props.index].teamName = e.target.value;
            this.setState({
                team: team
            });
        } else {
            this.setState({
                staffId: e.target.value
            });
        }
    }
    handleClick(e) {
        //update to server
        userSetAction.team(this.state.team);
        this.props.shouldModalClose(false);
    }
    handleCheck(e) {
        let checked = e.target.checked;
        let staffId = e.target.value;
        let userName = e.target.getAttribute('data-username');

        let team = this.state.team;
        if (checked) {
            team[this.props.index].teamMember.push({
                staffId: staffId,
                userName: userName
            });
        } else {
            //remove from list
            let len = team[this.props.index].teamMember.length;
            for (let i = 0; i < len; i++) {
                if (team[this.props.index].teamMember[i].staffId == staffId) {
                    team[this.props.index].teamMember.splice(i, 1);
                    break;
                }
            }
        }
        this.setState({
            team: team
        });
    }
    modalClose() {
        this.props.shouldModalClose(false);
    }
    checkStaff(staff) {
        let isCheck = false;
        if (this.state.team[this.props.index]) {
            let len = this.state.team[this.props.index].teamMember.length;
            for (let i = 0; i < len; i++) {
                if (this.state.team[this.props.index].teamMember[i].staffId == staff.staffId) {
                    isCheck = true;
                    break;
                }
            }
        }
        return isCheck;
    }
    renderDetail(staff, index) {
        //check if this facility is included;
        let isCheck = this.checkStaff(staff);

        return (
            <li className="pm-li-1" key={index}>
                <div className="checkbox">
                    <label>
                        <input type="checkbox" value={staff.staffId} data-username={staff.userName} onChange={this.handleCheck} checked={isCheck} />
                        <span className="checkmark"></span>
                        {staff.userName}
                    </label>
                </div>
            </li>
        )
    }
    renderList(staffs) {
        return staffs.map((staff, index) => {
            return this.renderDetail(staff, index);
        });
    }
    renderStaff() {
        if (this.props.staffs.length > 0) {
            let staffs = this.props.staffs.filter((staff) => {
                return (
                    staff.userName.toLowerCase().indexOf(this.state.staffId.toLowerCase()) > -1 ||
                    staff.staffId.toLowerCase().indexOf(this.state.staffId.toLowerCase()) > -1
                );
            });

            return this.renderList(staffs);
        }
    }

    renderContent() {
        return (
            <div>
                <form >
                    <div className="form-group">
                        <label htmlFor="teamName">Team Name</label>
                        <input type="text" className="form-control" id="teamName" placeholder="Type Team Name Here"
                            value={this.state.team[this.props.index] ? this.state.team[this.props.index].teamName : ""}
                            onChange={this.handleChange} data-index="0" />
                    </div>
                </form>
                <form >
                    <div className="form-group">
                        <label htmlFor="staffFilter">Staff:</label>
                        <input type="text" className="form-control" id="staffFilter" placeholder="Search By name or ID"
                            onChange={this.handleChange} data-index="1" />
                    </div>
                </form>
                <div className="divider"></div>
                <ul className="pm-ul" style={{ height: (this.state.clientHeight - 280) + "px", overflow: "auto" }}>
                    {this.renderStaff()}
                </ul>
            </div>
        )

    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="permission-modal" style={{ visibility: style.visibility }} ref="modal">
                    <div className="modal-header">
                        <h4 className="modal-title" >Edit Team</h4>
                    </div>

                    <div className="modal-body" style={{ height: (this.state.clientHeight - 115) + "px" }}>
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-warning" onClick={this.handleClick}>Done</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default TeamModal;


// WEBPACK FOOTER //
// ./app/setComponents/userSetComponents/teamModal.js